const FR_FLAG_IMAGE = [
  {
    src: new URL(
      '~/public/assets/images/languages/fr.png?as=webp',
      import.meta.url
    ).href,
    alt: 'FR',
    as: 'image/webp'
  },
  {
    src: new URL('~/public/assets/images/languages/fr.png', import.meta.url)
      .href,
    alt: 'FR',
    as: 'image/png'
  }
]

export default FR_FLAG_IMAGE
